import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const token = searchParams.get('token');
    
    console.log('AuthCallback: Processing callback parameters');
    
    if (!token) {
      console.error('AuthCallback: No token received');
      setError('Authentication failed. No token received.');
      setTimeout(() => navigate('/login', { replace: true }), 3000);
      return;
    }
    
    // Store token
    localStorage.setItem('token', token);
    console.log('AuthCallback: Token stored');
    
    // Fetch user data
    const fetchUserData = async () => {
      try {
        console.log('AuthCallback: Getting user profile');
        const response = await api.get('/auth/profile');
        const user = response.data;
        
        // Validate user data
        if (!user || !user.id || !user.email || !user.name) {
          throw new Error('Invalid user data received from server');
        }
        
        // Ensure permissions exist
        if (!user.permissions) {
          console.warn('Server did not provide permissions, initializing as empty array');
          user.permissions = [];
        }
        
        console.log('AuthCallback: User data fetched successfully');
        login(token);
        navigate('/', { replace: true });
      } catch (err) {
        console.error('Error fetching user profile:', err);
        setError('Failed to get user profile. Please try again.');
        localStorage.removeItem('token');
        setTimeout(() => navigate('/login', { replace: true }), 3000);
      }
    };
    
    fetchUserData();
  }, [navigate, searchParams, login]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh'
      }}
    >
      {error ? (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      ) : (
        <>
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>
            Completing sign in...
          </Typography>
        </>
      )}
    </Box>
  );
};

export default AuthCallback; 